import MuiOutlinedInput from '@mui/material/OutlinedInput';
import { forwardRef } from 'react';

interface IPropsInput {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  error?: boolean;
  dataTestId?: string;
}

export const InputPinCode = forwardRef(({ onChange, onKeyDown, autoFocus, error, dataTestId }: IPropsInput, ref) => {
  return (
    <MuiOutlinedInput
      autoFocus={autoFocus}
      inputRef={ref}
      size="small"
      color="primary"
      type="number"
      onChange={onChange}
      onKeyDown={onKeyDown}
      inputProps={{ maxLength: 1, 'data-testid': dataTestId }}
      error={error}
      sx={theme => ({
        width: '56px',
        input: {
          textAlign: 'center',
          typography: 'body1',
          color: 'text.secondary',
          height: '39px',
          '&[type=number]': {
            '-moz-appearance': 'textfield'
          },
          '&::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
          },
          '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
          },
          '&:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.default} inset`
          }
        },
        fieldset: {
          legend: {
            width: 'unset'
          }
        }
      })}
    />
  );
});

InputPinCode.displayName = 'InputPinCode';
export default InputPinCode;
